﻿
import { ioDatatypes } from "../../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter, ReactBootstrap, ReactLoader as Loader, Cookie } from "../../blib.js";

import * as xlib from "../../../../xlib/index.js";
import * as blib from "../../../../blib/index.js";


import { IndexRoute, Router, Route, Link } from "react-router";

///////////////////  APP FOLLOWING PATTERNS FROM: http://localhost:8080/auth-with-shared-root/   (react-router example)


import bluebird from "bluebird";


//import Cookie = blib.Cookie;

//import xlib = refs.xlib;
// var _ = xlib.lodash;
// var __ = xlib.lolo;
var log = new xlib.diagnostics.logging.Logger( __filename );
xlib.diagnostics.logging.logPromiseUnhandledRejections();
//var jsHelper = xlib.jsHelper;

//import blib = refs.blib;


// import React = blib.React;
// import ReactDOM = blib.ReactDOM;
// import Redux = blib.Redux;
// import ReactRedux = blib.ReactRedux;
// import ReactRouter = blib.ReactRouter; //tested with 1.x, not sure if it works with 2.x
// import History = blib.History;
// import ReactBootstrap = blib.ReactBootstrap;
//var ReduxSimpleRouter = blib.ReduxSimpleRouter;

//import ioDatatypes = refs.ioDatatypes;

import * as config from "../client-config.js";

import * as commonComponents from "./commoncomponents.js";

import { errorPopupContent } from "./error-popup.js";
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////

export module components {

	let ReactRecaptcha = blib.ReactRecaptcha;

	class _StartReset extends commonComponents.ReactRouterComponent<{ pushPath: typeof ReduxSimpleRouter.pushPath }, { email?: string; recaptchaResponse?: string; triedSubmitWithoutRecaptch?: boolean; }>{
		constructor( props: any ) {
			super( props );
			this.state = { email: null, recaptchaResponse: null, triedSubmitWithoutRecaptch: false };
		}

		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();
		}
		render() {

			//isOpen={this.state.showError} 
			//            title="Error Starting the Password Reset Process" 
			//            message="Error.  Please carefully retype your email and try again.  Technical details of the error:" 
			//            details={this.state.errorDetailsFromServer} 
			//            onCloseRequest={this.CloseErrorModal.bind(this) } 
			//            />
			return (
				<div>
					<commonComponents.EzModal ref="Modal" />
					<div className="card">
						<div className="card-block">

							<div className="card-title">
								<h4>Reset your Password</h4>
							</div>
							<form onSubmit={ this.handleSubmit.bind( this ) } >
								<fieldset className="form-group">
									<label htmlFor="emailInput">Email address</label>
									<input type="email" className="form-control" id="emailInput" placeholder="Enter email" value={ this.state.email } onChange={ ( e: React.FormEvent ) => { this.setState( { email: e.target.value } ) } } />
								</fieldset>

								<ReactRecaptcha sitekey={ config.RECAPTCHA_SITE_KEY } onChange={ this.onRecaptchaResponse.bind( this ) } />
								<br />
								{ this._render_SubmitAfterRecaptcha() }
							</form>
						</div>
					</div>

				</div>
			);
			//<div className="col-sm-12">Already have the ResetKey?<ReactRouter.Link to={config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.resetPasswordFinish}><strong>Finish the Password Reset Here</strong></ReactRouter.Link>.</div>

		}

		private _render_SubmitAfterRecaptcha() {

			if ( this.state.recaptchaResponse == null ) {
				return (
					<div>
						<button className="btn btn-default" onClick={ ( e ) => { e.preventDefault(); this.setState( { triedSubmitWithoutRecaptch: true } ); } }><div className="muted">Reset Password</div></button>&nbsp;
						<div hidden={ this.state.triedSubmitWithoutRecaptch !== true } className="label label-danger">Please do the above CAPTCHA first!</div>
					</div> )
			} else {
				return (
					<button type="submit" className="btn btn-primary">Reset Password</button>
				);
			}
		}
		private onRecaptchaResponse( recaptchaResponse: string ) {
			this.setState( { recaptchaResponse } );
		}

		//private openConfirmModal(email:string) {
		//             var modal = this.refs["Modal"] as commonComponents.EzModal;

		//	let title = <span>Send Reset email to <strong>{email}</strong>?</span>
		//	let message = <span>Please make sure you entered your email address correctly.  If not, cancel and re-submit.</span>
		//	//let details = <h3>{email}</h3>
		//             return modal.Show(title, message, null, { confirmButtonText: "Send Email" });
		//         }

		private openSuccessModal( email: string ) {
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;

			let title = <span><strong>{ email }</strong> Finish Resetting your Password.</span>
			let message = <span>An email was sent to you from Support@PhantomJsCloud.com.  Please open it and follow it's instructions to reset your password.  <strong>You must complete this process in 1 hour or you will need to restart it again.</strong></span>
			//let details = <h3>{email}</h3>
			return modal.Show( title, message );
		}
		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error Starting the Password Reset Process", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		private handleSubmit( e: React.FormEvent ) {
			//log.trace("Login.handleSubmit", e);
			e.preventDefault(); //prevent browser default action of submitting

			let email = this.state.email;

			let recaptchaResponse = this.state.recaptchaResponse;
			//return this.openConfirmModal(email)
			//	.then(() => {
			var origin = window.location.origin;
			var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_resetPassword_start;

			log.debug( target );
			return bluebird.try( () => {
				return xlib.net.axiosPost( target, { email: this.state.email, recaptchaResponse } )
					.then( ( response ) => {
						//var responsePayload = response.data;
						//log.info("Login.handleSubmit.responsePayload", response);
						return this.openSuccessModal( this.state.email )
							.then( () => {
								this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.root );
							} );
					} )
					.catch( ( err ) => {
						const errData = err.response == null ? "NONE" : err.response.data;
						log.debug( "response from server:", errData );
						return this.openErrorModal( "response from server:", errData );
					} );
			} );
			//});
		}
	}
	export var StartReset = ReactRedux.connect(
		null //(reduxStoreState) => _.clone(reduxStoreState.modalPopup) //subscripbe to reduxStore updates (Called every change). 
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _StartReset );


	class _EndReset extends commonComponents.ReactRouterComponent<{ pushPath: typeof ReduxSimpleRouter.pushPath }, { email?: string; resetToken?: string; password?: string; passwordConfirm?: string; isAutoFilledFieldsReadOnly?: boolean; }>{
		constructor( props: any ) {
			super( props );
			this.state = { email: null, resetToken: null, password: null, passwordConfirm: null };
		}

		componentWillMount() {
			//send page hit
			blib.ga_ezSpaPageHit();

			//look for querystrings

			let email = this.props.location.query[ "email" ];
			if ( email == null && this.props.location.query[ "emailEnc" ] != null ) {
				email = xlib.stringHelper.base64Url.decode( this.props.location.query[ "emailEnc" ] );
			}
			let resetToken = this.props.location.query[ "resetToken" ];
			if ( resetToken == null && this.props.location.query[ "resetTokenEnc" ] != null ) {
				resetToken = xlib.stringHelper.base64Url.decode( this.props.location.query[ "resetTokenEnc" ] );
			}

			let isAutoFilledFieldsReadOnly = false;
			if ( email != null && resetToken != null ) {
				isAutoFilledFieldsReadOnly = true;
			}


			//log.info("props", this.props);  
			this.setState( { email, resetToken, isAutoFilledFieldsReadOnly } );
		}
		//componentDidMount() {

		//}

		render() {

			return (
				<div>
					<commonComponents.EzModal ref="Modal" />
					<div className="card">
						<div className="card-block">

							<div className="card-title">
								<h4><strong>{ this.props.location.query[ "email" ] }</strong> Finish Resetting your Password.</h4>
								<p>An email was sent to you from <b><a href="mailto:Support@PhantomJsCloud.com">Support@PhantomJsCloud.com</a></b>.  Please open it and follow it's instructions to reset your password.<strong><em>You must complete this process in 1 hour or you will need to restart it again.</em></strong></p>
							</div>
							<form onSubmit={ this.handleSubmit.bind( this ) } >
								<fieldset className="form-group">
									<label htmlFor="resetToken">Reset Token</label>
									<input
										type="text"
										className="form-control"
										id="resetToken"
										placeholder="a1b2c-a1b2c-a1b2c-a1b2c-a1b2c"
										value={ this.state.resetToken }
										onChange={ ( e: React.FormEvent ) => { this.setState( { resetToken: e.target.value } ) } }
										readOnly={ this.state.isAutoFilledFieldsReadOnly }
									/>
								</fieldset>
								<fieldset className="form-group">
									<label htmlFor="emailInput">Email address</label>
									<input
										type="email"
										className="form-control"
										id="emailInput"
										placeholder=""
										value={ this.state.email }
										onChange={ ( e: React.FormEvent ) => { this.setState( { email: e.target.value } ) } }
										readOnly={ this.state.isAutoFilledFieldsReadOnly }
									/>
								</fieldset>
								<fieldset className="form-group">
									<label htmlFor="password">New Password</label>
									<input
										type="password"
										className="form-control"
										id="password"
										placeholder=""
										value={ this.state.password }
										onChange={ ( e: React.FormEvent ) => { this.setState( { password: e.target.value } ) } }
									/>
								</fieldset>
								<fieldset className="form-group">
									<label htmlFor="password">Retype New Password</label>
									<input
										type="password"
										className="form-control"
										id="passwordConfirm"
										placeholder=""
										value={ this.state.passwordConfirm }
										onChange={ ( e: React.FormEvent ) => { this.setState( { passwordConfirm: e.target.value } ) } }
									/>
								</fieldset>

								<button type="submit" className="btn btn-primary">Change Password Now</button>
							</form>
						</div>
					</div>
					<div className="col-sm-12">Dont have a valid Reset Token?<ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.resetPasswordStart }><strong>Restart the password reset request</strong></ReactRouter.Link>.</div>
				</div>
			);

		}

		private openSuccessModal( email: string ) {
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;

			let title = <span>Password for <strong>{ email }</strong> is reset.</span>
			let message = <span>You will now automatically Log In.</span>
			//let details = <h3>{email}</h3>
			return modal.Show( title, message );
		}

		private openErrorModal( ...errorDetails: any[] ) {
			const content = errorPopupContent( "Error Finalizing the Password Reset Process", ...errorDetails );
			var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
			if ( modal != null ) {
				return modal.ShowError( content );
			}
			log.error( content.title, content.message, content.technicalDetails );
		}

		private handleSubmit( e: React.FormEvent ) {
			//log.assert(false,"EndReset.handleSubmit", e);
			e.preventDefault(); //prevent browser default action of submitting

			//verify both passwords match
			if ( this.state.password !== this.state.passwordConfirm ) {
				this.openErrorModal( "The passwords you typed do not match" );
				return;
			}
			try {


				__.scrub( this.state ).isReal( "all fields are required", true ).failThrow();

				var resetToken = xlib.security.humanFriendlyKey( undefined, undefined, this.state.resetToken );

				var passwordHash = xlib.security.sha512( this.state.password );



				var origin = window.location.origin;
				var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_resetPassword_finish;

				let payload: ioDatatypes.authentication.Payload_ResetPasswordFinish = {
					//var payload: typeof ioDatatypes.authentication.templates.T_payload_resetPasswordFinish = {
					email: this.state.email,
					passwordSha512Hash: passwordHash,
					resetToken: resetToken,
				};
				log.debug( target );
				xlib.net.axiosPost( target, payload )
					.then( ( response ) => {
						return this.openSuccessModal( this.state.email )
							.then( () => {
								//var responsePayload = response.data;
								//log.info("Login.handleSubmit.responsePayload", response);
								this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.root );
							} )
					} )
					.catch( ( err ) => {
						this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
					} );
			} catch ( err ) {
				this.openErrorModal( err );
			}
		}
	}
	export var EndReset = ReactRedux.connect(
		null //(reduxStoreState) => _.clone(reduxStoreState.modalPopup) //subscripbe to reduxStore updates (Called every change). 
		, _.merge( {}, {}, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
	)( _EndReset );




}

